import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { API } from "../../shared/api";
import { deleteRemarksData, fetchRemarksData, updateRemarksData, fetchRemarksError, deleteRemarksError, deleteRemarksSuccess } from "./admin.action";
import { EMPTY, catchError, map, switchMap, tap, of } from "rxjs";
import { RemarkData } from "../../models/remarkDataModel";

@Injectable()
export class AdminEffects {

    constructor(private action$: Actions, private api: API) {}

    fetchRemarksData$ = createEffect(() => this.action$.pipe(
        ofType(fetchRemarksData),
        switchMap(() => this.api.getRemarks().pipe(
            map((remarksData: RemarkData[]) => updateRemarksData({ remarksData: remarksData })),
            catchError((error) => {
                console.error('Error fetching remarks data:', error);
                // Return both the empty data update and the error action
                return of(
                    updateRemarksData({ remarksData: [] }),
                    fetchRemarksError({ error })
                );
            })
        ))
    ))

    deleteRemarkData$ = createEffect(() => this.action$.pipe(
        ofType(deleteRemarksData),
        switchMap(({id}) => this.api.deleteRemark(id).pipe(
            switchMap(() => [
                deleteRemarksSuccess({ id }),
                fetchRemarksData() // Refetch data after successful delete
            ]),
            catchError((error) => {
                console.error('Error deleting remark:', error);
                // Return both the error action and still refetch to show current state
                return of(
                    deleteRemarksError({ error }),
                    fetchRemarksData()
                );
            })
        ))
    ))
}
